// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label____8Gz","input":"styles_input__2PJyI","fadeInOut":"styles_fadeInOut__yNKw6","loader":"styles_loader__fCFvR"};